(() => {
  const modal = document.getElementById('StoreSelectorModal');

  if (!modal || modal.dataset.storeSelectorReady === 'true') return;

  modal.dataset.storeSelectorReady = 'true';

  const dialog = modal.querySelector('.store-selector-modal__dialog');
  const form = modal.querySelector('.store-selector-modal__form');
  const countrySelect = modal.querySelector('.js-store-selector-country');
  const languageSelect = modal.querySelector('.js-store-selector-language');
  const submitButton = modal.querySelector('.js-store-selector-submit');
  const picker = modal.querySelector('.js-store-selector-picker');
  const pickerToggle = modal.querySelector('.js-store-selector-picker-toggle');
  const pickerMenu = modal.querySelector('.js-store-selector-menu');
  const pickerFlag = modal.querySelector('[data-store-selector-picker-flag]');
  const pickerValue = modal.querySelector('[data-store-selector-picker-value]');
  const globalToggle = modal.querySelector('.js-store-selector-global');
  const globalCountries = modal.querySelector('[data-store-selector-global-countries]');
  const countrySummary = modal.querySelector('[data-store-selector-country]');
  const languageSummary = modal.querySelector('[data-store-selector-language]');
  const currencySummary = modal.querySelector('[data-store-selector-currency]');
  let opener = null;

  const renderFlag = (element, countryCode) => {
    if (!element) return;

    const code = String(countryCode || '').trim().toUpperCase();
    if (!/^[A-Z]{2}$/.test(code)) {
      element.replaceChildren();
      return;
    }

    const image = document.createElement('img');
    image.src = `https://cdn.shopify.com/static/images/flags/${code.toLowerCase()}.svg`;
    image.alt = '';
    image.width = element.classList.contains('store-selector-trigger__flag') ? 20 : 24;
    image.height = image.width;
    element.dataset.countryFlag = code;
    element.replaceChildren(image);
  };

  const initializeFlags = () => {
    document.querySelectorAll('[data-country-flag]').forEach((element) => {
      renderFlag(element, element.dataset.countryFlag);
    });
  };

  const selectedOption = (select) => select && select.options[select.selectedIndex];

  const closeCountryPicker = () => {
    if (!pickerMenu || !pickerToggle) return;
    pickerMenu.hidden = true;
    pickerToggle.setAttribute('aria-expanded', 'false');
    picker.classList.remove('is-open');
  };

  const openCountryPicker = () => {
    if (!pickerMenu || !pickerToggle) return;
    pickerMenu.hidden = false;
    pickerToggle.setAttribute('aria-expanded', 'true');
    picker.classList.add('is-open');
  };

  const toggleGlobalCountries = () => {
    if (!globalToggle || !globalCountries) return;
    const expanded = globalToggle.getAttribute('aria-expanded') === 'true';
    globalToggle.setAttribute('aria-expanded', String(!expanded));
    globalCountries.hidden = expanded;
  };

  const updateSummary = () => {
    const country = selectedOption(countrySelect);
    const language = selectedOption(languageSelect);

    if (country) {
      const countryCode = country.dataset.countryCode || country.value;
      const countryName = country.dataset.countryName || country.textContent.trim();
      const currency = country.dataset.currency || '';

      renderFlag(pickerFlag, countryCode);
      if (pickerValue) pickerValue.textContent = `${countryName} / ${currency}`;
      if (countrySummary) countrySummary.textContent = countryName;
      if (currencySummary) currencySummary.textContent = currency;

      modal.querySelectorAll('.js-store-selector-country-option').forEach((button) => {
        const selected = button.dataset.countryCode === countryCode;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-selected', String(selected));
      });
    }

    if (languageSummary && language) languageSummary.textContent = language.textContent.trim();
  };

  const selectCountry = (button) => {
    if (!countrySelect || !button) return;

    countrySelect.value = button.dataset.countryCode || '';
    countrySelect.dispatchEvent(new Event('change', { bubbles: true }));
    closeCountryPicker();
    pickerToggle.focus();
  };

  const openModal = (button) => {
    opener = button || null;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('store-selector-open');
    document.body.classList.remove('lang-currency-sidebar-show');
    closeCountryPicker();
    updateSummary();

    window.requestAnimationFrame(() => {
      if (pickerToggle) pickerToggle.focus();
      else if (dialog) dialog.focus();
    });
  };

  const closeModal = () => {
    closeCountryPicker();
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('store-selector-open');

    if (opener && document.contains(opener)) opener.focus();
    opener = null;
  };

  document.addEventListener('click', (event) => {
    const countryOption = event.target.closest('.js-store-selector-country-option');
    if (countryOption && modal.contains(countryOption)) {
      event.preventDefault();
      selectCountry(countryOption);
      return;
    }

    const globalButton = event.target.closest('.js-store-selector-global');
    if (globalButton && modal.contains(globalButton)) {
      event.preventDefault();
      toggleGlobalCountries();
      return;
    }

    const pickerButton = event.target.closest('.js-store-selector-picker-toggle');
    if (pickerButton && modal.contains(pickerButton)) {
      event.preventDefault();
      const expanded = pickerButton.getAttribute('aria-expanded') === 'true';
      expanded ? closeCountryPicker() : openCountryPicker();
      return;
    }

    const openButton = event.target.closest('.js-store-selector-open');
    if (openButton) {
      event.preventDefault();
      openModal(openButton);
      return;
    }

    const clickedBackdrop = event.target === modal || event.target.matches('[data-store-selector-close]');
    const clickedCloseButton = event.target.closest('.store-selector-modal__close');
    if (modal.classList.contains('is-open') && (clickedBackdrop || clickedCloseButton)) {
      event.preventDefault();
      closeModal();
      return;
    }

    if (picker && picker.classList.contains('is-open') && !picker.contains(event.target)) closeCountryPicker();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !modal.classList.contains('is-open')) return;

    if (picker && picker.classList.contains('is-open')) {
      closeCountryPicker();
      pickerToggle.focus();
      return;
    }

    closeModal();
  });

  if (countrySelect) countrySelect.addEventListener('change', updateSummary);
  if (languageSelect) languageSelect.addEventListener('change', updateSummary);

  if (form) {
    form.addEventListener('submit', () => {
      if (!submitButton) return;
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
    });
  }

  initializeFlags();
  updateSummary();
})();
